module.exports = __webpack_public_path__ + "img/manageit-digital_logo.7737fab5.png";